import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import App from './App';
import LoginScreen from './components/LoginScreen';
import MobileTimeEntry from './components/MobileTimeEntry';
import { authAPI, surSessionPerdue } from './services/api';

// Porte d'entrée de l'app : personne n'atteint un écran sans être connecté.
// Selon le rôle, on ouvre l'application complète (patron) ou l'écran de saisie
// des heures (chef d'équipe, salarié), qui ne montre aucun montant.
const AppShell = () => {
  const [user, setUser] = useState(undefined); // undefined = on interroge encore le serveur
  const [terrain, setTerrain] = useState(false);  // patron basculé sur l'écran de saisie

  useEffect(() => {
    // Session expirée ou fermée depuis un autre appareil : retour à la connexion.
    surSessionPerdue(() => setUser(null));
    authAPI.me()
      .then(({ user: connecte }) => setUser(connecte))
      .catch(() => setUser(null));
  }, []);

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-blue-50">
        <Loader2 className="w-12 h-12 text-green-600 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <LoginScreen onLogged={setUser} />;
  }

  if (user.role === 'chef' || user.role === 'salarie') {
    return <MobileTimeEntry user={user} onLoggedOut={() => setUser(null)} />;
  }

  // Le patron reçoit l'application complète, pensée pour un écran d'ordinateur.
  // Depuis un téléphone, il peut basculer sur l'écran de saisie — le même que
  // l'équipe — et revenir.
  if (terrain) {
    return <MobileTimeEntry user={user} onLoggedOut={() => setUser(null)}
                            onRetour={() => setTerrain(false)} />;
  }

  return <App user={user} onLoggedOut={() => setUser(null)}
              onSaisieTerrain={() => setTerrain(true)} />;
};

export default AppShell;
